import { loadDOMImage } from 'ff-canvas';

export const loadImage = (url: string) => loadDOMImage(url, 'anonymous');